import gql from 'graphql-tag';

export const createCheckupReservationForIndividual = gql`
  mutation createCheckupReservationForIndividual($input: ReserveCheckupAppointmentInput!) {
    reserveCheckupAppointmentIndividual(input: $input) {
      id
    }
  }
`;
